import { getCurrentInstance } from "vue"

import Plugin from "./Plugin"

declare module "@vue/runtime-core" {
  export interface ComponentCustomProperties {
    $modal: any
  }
}

export { default as Modal } from "./components/Modal.vue"
export { default as Dialog } from "./components/Dialog.vue"
// export { default as ModalsContainer } from './components/ModalsContainer.vue'

export const version = "__VERSION__"

// Install by default if using the script tag
// if (typeof window !== 'undefined' && window.Vue) {
//   window.Vue.use(install)
// }

export function useModal() {
  const instance = getCurrentInstance()
  if (!instance) {
    throw new Error("useModal() must be called within setup()")
  }

  const modal = instance.appContext.config.globalProperties.$modal

  return {
    show: (name: string, params?: any) => modal.show(name, params),
    hide: (name: string) => modal.hide(name),
    toggle: (name: string, state?: boolean, params?: any) => modal.toggle(name, state, params)
  }
}

export default Plugin
